import request from "@/utils/request";

export async function mega() {
  return await request.get("/menus/mega_menu/items", { data: null });
}

export async function footer() {
  return await request.get("/menus/footer_menu/items", { data: null });
}
